import ReactDOM from 'react-dom';
import App from './App';
import { AuthContextProvider } from './hooks/useAuth';

ReactDOM.render(
  <AuthContextProvider>
    <App />
  </AuthContextProvider>,
  document.getElementById('root'),
);
